export const minutes5inMS = 300000;
export const minutes30inMS = minutes5inMS * 6;
export const days1inMS = 86400000;

export const years1 = 31557600;
